/** @format */

import type { HomrBadgeBoxShadowOptions } from '../dropdown-options.types';

export interface HomrBadge {
  backgroundColor?: string;
  badgeBoxShadow?: HomrBadgeBoxShadowOptions;
  badgeText?: string;
  badgeType?: string;
  foregroundColor?: string;
}
